interface MembershipPermissionFeatures {
  tenantRegistration: string;
  propertyRegistration: string;
  disableAndReactivateRequests: string;
  tenantTracker: string;
  tenantMultireport: string;
  tenantMultireportExpress: string;
  creditBureauPDF: string;
  fileExpedientZIP: string;
  reportDistributor: string;
  advisorManager: string;
  organizationPropertyCatalog: string;
  organizationTenantCatalog: string;
  userPrivacy: string;
}

const permissions: MembershipPermissionFeatures = {
  tenantRegistration: "tenantRegistration",
  propertyRegistration: "propertyRegistration",
  disableAndReactivateRequests: "disableandReactivateRequests",
  tenantTracker: "tenantTracker",
  tenantMultireport: "tenantMultireport",
  tenantMultireportExpress: "tenantMultireportExpress",
  creditBureauPDF: "creditBureauPDF",
  fileExpedientZIP: "fileExpedientZIP",
  reportDistributor: "reportDistributor",
  advisorManager: "advisorManager",
  organizationPropertyCatalog: "organizationPropertyCatalog",
  organizationTenantCatalog: "organizationTenantCatalog",
  userPrivacy: "userPrivacy",
};

export default permissions;
